var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard", class: { "is-collapsed": _vm.collapsed } },
    [
      _c(
        "button",
        {
          staticClass: "rail-collapse-toggle",
          attrs: {
            type: "button",
            title: _vm.collapsed ? "Panel einblenden" : "Panel ausblenden",
          },
          on: { click: _vm.toggle },
        },
        [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v(_vm._s(_vm.collapsed ? "chevron_left" : "chevron_right")),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.collapsed ? _vm._t("default") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }